/** Carry invitation/deep links through sign-in and MFA without external redirects. */
export function authReturnPath(value: string | null | undefined): string {
  if (!value?.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020]/.test(value)) return '/auth/org-select';
  try {
    const url = new URL(value, 'https://seer.invalid');
    return url.origin === 'https://seer.invalid' ? url.pathname + url.search + url.hash : '/auth/org-select';
  } catch { return '/auth/org-select'; }
}
